module.exports = __webpack_public_path__ + "img/day1.9ad42749.svg";